import CheckIcon from "@mui/icons-material/Check";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import { Sheet, List, ListItem, Typography } from "@financeable-com-au/financeable-ui";

interface AuthPasswordStrengthProps {
  password: string;
}

const getRequirementTextColor = (isMet: boolean) => (isMet ? "success.200" : "danger.200");

const AuthPasswordStrength = ({ password }: AuthPasswordStrengthProps) => {
  const requirements = [
    {
      label: "At least 14 characters long",
      isMet: password.length >= 14,
    },
    {
      label: "Contains at least 1 number",
      isMet: /\d/.test(password),
    },
    {
      label: "Contains 1 special character",
      isMet: /[^a-zA-Z0-9]/.test(password),
    },
  ];

  return (
    <Sheet variant="outlined" borderRadius="md" padding={1} aria-label="Password requirements">
      <List sx={{ "--ListItem-minHeight": "1.2rem" }}>
        {requirements.map((requirement) => (
          <ListItem key={requirement.label} sx={{ py: 0 }}>
            {requirement.isMet ? (
              <CheckIcon sx={{ color: "var(--joy-palette-success-200)", fontSize: "0.75rem" }} />
            ) : (
              <DoNotDisturbIcon sx={{ color: "var(--joy-palette-danger-200)", fontSize: "0.75rem" }} />
            )}
            <Typography level="body-xs" lineHeight={1.2} textColor={getRequirementTextColor(requirement.isMet)}>
              {requirement.label}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Sheet>
  );
};

export { AuthPasswordStrength };
